const PropTypes = require('prop-types');
const React = require('react');

const StandaloneAjaxAddToCartButton = require('components/listings/cart/standalone_ajax_add_to_cart_button.jsx');
const Upsells = require('components/product_show_page/upsells.jsx');
const SidebarUpsellPlaceholder =
  require('components/product_show_page/sidebar_upsell_placeholder.jsx');

const SidebarUpsells = (props) => (
  <Upsells
    listingId={props.listingId}
    className={props.className}
    children={props.children}
    aid={'related_content_upsells_product_show_page'}
    addToCartButton={StandaloneAjaxAddToCartButton}
    placeholder={<SidebarUpsellPlaceholder />}
    showSidebarUpsell
  />
);

SidebarUpsells.propTypes = {
  listingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  children: PropTypes.node,
};

module.exports = SidebarUpsells;



// WEBPACK FOOTER //
// ./javascripts/components/product_show_page/sidebar_upsells.jsx